export const STATUS_CODES = {
    OK: '200',
    BAD_REQUEST: '400',
    UNAUTHORIZED: '401',
    FORBIDDEN: '403',
    NOT_FOUND: '404',
    SERVER_ERROR: '500'
};